/* Majova Point – order-request page (/pages/bestallning?p=<key>&q=<qty>).
   Recomputes the order from MPCore.catalog() + MPCore.calc() (never trusts prices in the URL),
   fills the summary, and posts the B2B order request. Needs mp-core.js and mp-forms.js (defer). */
(function (root) {
  'use strict';

  // POST field names accepted by apps-script/Code.gs orderRequest_().
  var FIELDS = ['company', 'vat', 'contact', 'email', 'phone', 'street', 'zip', 'city',
    'invoice_email', 'bill_street', 'bill_zip', 'bill_city', 'reference', 'hp'];
  var CATALOG_TIMEOUT_MS = 10000;
  var POST_TIMEOUT_MS = 25000;

  function hasOwn(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  function isAmount(n) { return typeof n === 'number' && isFinite(n) && n >= 0; }

  /* ------------------------------------------------------- pure (tested) */

  // -> {product, title, qty, unit, subtotal, shipping, total} or null.
  function orderFrom(catalog, key, qty, calc) {
    if (!catalog || typeof catalog !== 'object' || typeof key !== 'string' || !hasOwn(catalog, key) || !qty) return null;
    var product = catalog[key];
    if (!product || typeof product !== 'object') return null;
    var c = calc(product, qty);
    if (!c || !isAmount(c.unit) || !isAmount(c.subtotal) || !isAmount(c.shipping) || !isAmount(c.total) ||
        !(c.qty >= 1) || c.unit <= 0) return null;
    return {
      product: key,
      title: String(product.title || key),
      qty: c.qty,
      unit: c.unit,
      subtotal: c.subtotal,
      shipping: c.shipping,
      total: c.total
    };
  }

  // The order_request POST body. Hidden conditional fields arrive missing and are sent as ''.
  // No visitor or session id: the backend only needs the smoke flag (visit.smoke: the ad link's
  // marker is in this page's address). rid = request id, one per page view, so a retry after a lost
  // response is not stored or mailed twice.
  function payload(data, order, visit, qa, rid) {
    var V = root.MPForms.validators;
    var out = { action: 'order_request' };
    FIELDS.forEach(function (k) {
      out[k] = data && data[k] !== undefined && data[k] !== null ? String(data[k]).trim() : '';
    });
    out.vat = V.normVat(out.vat);
    out.zip = V.normZip(out.zip);
    out.bill_zip = out.bill_zip ? V.normZip(out.bill_zip) : '';
    out.product = order.product;
    out.title = order.title;
    out.qty = order.qty;
    out.unit = order.unit;
    out.subtotal = order.subtotal;
    out.shipping = order.shipping;
    out.total = order.total;
    out.rid = rid ? String(rid) : '';
    out.smoke = !!(visit && visit.smoke === true);
    out.qa = qa === true;
    return out;
  }

  /* --------------------------------------------------------------- page */

  function core() { return root.MPCore || null; }

  function num(n) {
    var C = core();
    return C && typeof C.num === 'function' ? C.num(n) : String(n);
  }

  function money(n) {
    var C = core();
    return C && typeof C.fmt === 'function' ? C.fmt(n) : String(n) + ' kr';
  }

  function resolve(box) {
    var C = core();
    if (!C || typeof C.catalog !== 'function') return Promise.resolve(null);
    var key = null;
    var rawQty = null;
    try {
      var params = new URLSearchParams(root.location.search);
      key = params.get('p');
      rawQty = params.get('q');
    } catch (e) { /* ignore */ }
    if (!key && rawQty === null) {
      // No parameters at all (e.g. the visitor came back via a bookmark): fall back to the order
      // started on the landing page in this browser. Prices are still recomputed below.
      var last = null;
      try { last = C.store.get('mp_order'); } catch (e) { last = null; }
      if (last && typeof last === 'object') {
        key = typeof last.product === 'string' ? last.product : null;
        rawQty = last.qty === undefined || last.qty === null ? null : String(last.qty);
      }
    }
    var qty = rawQty === null ? null : C.parseQty(rawQty);
    var design = box.hasAttribute('data-design-mode');
    var timer = null;
    var timeout = new Promise(function (done) { timer = setTimeout(function () { done(null); }, CATALOG_TIMEOUT_MS); });
    var loaded = Promise.resolve().then(function () { return C.catalog(); });

    return Promise.race([loaded, timeout]).then(function (cat) {
      clearTimeout(timer);
      if (design && cat && typeof cat === 'object') {
        // Theme editor has no ?p=&q=: preview with the first product so the layout is editable.
        if (!key || !hasOwn(cat, key)) key = Object.keys(cat)[0];
        if (!qty) qty = 1;
      }
      return orderFrom(cat, key, qty, function (p, q) { return C.calc(p, q); });
    }).catch(function () { return null; });
  }

  function put(box, key, text) {
    var el = box.querySelector('[data-mp-sum="' + key + '"]');
    if (el) el.textContent = text;
  }

  function fill(box, o) {
    put(box, 'title', o.title);
    put(box, 'qty', num(o.qty));
    put(box, 'unit', money(o.unit));
    put(box, 'subtotal', money(o.subtotal));
    put(box, 'shipping', money(o.shipping));
    put(box, 'total', money(o.total));
    var summary = box.querySelector('[data-mp-summary]');
    if (summary) summary.removeAttribute('aria-busy');
  }

  function show(box, selector, on) {
    var el = box.querySelector(selector);
    if (el) el.hidden = !on;
  }

  // loading | ready | invalid | sent
  function setState(box, state) {
    var editing = state === 'loading' || state === 'ready';
    box.setAttribute('data-state', state);
    show(box, '[data-mp-intro]', state !== 'sent');
    show(box, '[data-mp-lede]', editing);
    show(box, '[data-mp-invalid]', state === 'invalid');
    show(box, '[data-mp-thanks]', state === 'sent');
    show(box, '[data-mp-summary]', state !== 'invalid');
    show(box, '[data-mp-change]', state !== 'sent');
    show(box, '[data-mp-main]', editing);
  }

  function showThanks(box, id, focus) {
    var ref = box.querySelector('[data-mp-ref]');
    var refWrap = box.querySelector('[data-mp-ref-wrap]');
    if (ref && refWrap) {
      ref.textContent = id ? String(id) : '';
      refWrap.hidden = !id;
    }
    setState(box, 'sent');
    if (!focus) return;
    var heading = box.querySelector('[data-mp-thanks-heading]');
    try { root.scrollTo(0, 0); } catch (e) { /* ignore */ }
    if (heading) {
      try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
    }
  }

  function setup(box) {
    if (box.__mpBound) return;
    box.__mpBound = true;
    var F = root.MPForms;
    var form = box.querySelector('form[data-mp-form]');
    var preview = box.getAttribute('data-preview'); // theme editor only
    var rid = F && typeof F.requestId === 'function' ? F.requestId() : '';

    var ready = resolve(box).then(function (order) {
      if (!order || preview === 'invalid') {
        setState(box, 'invalid');
        return null;
      }
      fill(box, order);
      setState(box, 'ready');
      if (preview === 'sent') showThanks(box, 'MP-000000-000000-000', false);
      return order;
    });

    if (!F || !form) return;
    F.bind(form, {
      onSubmit: function (data) {
        return ready.then(function (order) {
          if (!order) return false;
          var C = core();
          var visit = { smoke: typeof C.smoke === 'function' && C.smoke() === true };
          return F.post(payload(data, order, visit, C.isQA() === true, rid), POST_TIMEOUT_MS).then(function (res) {
            if (!res || res.ok !== true) return res; // MPForms maps missing_<field> / bad_email to the field
            F.track('order_request_submit', {
              product: order.product, quantity: order.qty, value: order.total, currency: 'SEK'
            });
            showThanks(box, res.id, true);
            return true;
          });
        });
      }
    });
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : root.document;
    Array.prototype.forEach.call(host.querySelectorAll('[data-mp-order]'), setup);
  }

  root.MPOrder = { orderFrom: orderFrom, payload: payload, FIELDS: FIELDS };

  var doc = root.document;
  if (doc && typeof doc.addEventListener === 'function') {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
    else init(doc);
    doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})(typeof window !== 'undefined' ? window : this);
